import React from "react";

const AnimationOne = () => {
  return <div className="element"></div>;
};

export default AnimationOne;
